import './App.css';
import { Routes, Route, ScrollRestoration, useLocation } from 'react-router-dom'
import Home from './Pages/Home/Home';
import 'aos/dist/aos.css';
import AOS from 'aos';
import 'react-toastify/dist/ReactToastify.css';
import { useContext, useEffect, useRef, useState } from 'react';
import Navbar from './Components/Header/Navbar';
import WhyUs from './Pages/WhyUs/WhysUs';
import Footer from './Components/Footer/Footer';
import Approach from './Pages/Approaches/Approach';
import Portfolio from './Pages/Portfolio/Portfolio';
import ServiceAndWork from './Pages/ServiceAndWork/ServiceAndWork';
import { AnimatePresence } from 'framer-motion';
import About from './Pages/About/About';
import AnimatedHero from "./Components/Hero/AnimateHer"
import Contact from './Pages/Contact/Contact';
import { Slide, ToastContainer } from 'react-toastify';
function App() {
  const [scrol, setScroll] = useState()
  const [showNav, setShowNav] = useState('sideNav')
  const [preeLoader, setPreeLoader] = useState(true)
  const onScrollWindow = () => {
    const Scrolled = document.documentElement.scrollTop;
    const MaxHeight =
      document.documentElement.scrollHeight -
      document.documentElement.clientHeight;
    const ScrollPercent = (Scrolled / MaxHeight) * 100;
    setScroll(ScrollPercent);
  };

  useEffect(() => {

    const loaderTime = setTimeout(() => {
      setPreeLoader(false)
    }, 15000);


    // // return () => clearTimeout(loaderTime)
    // window.addEventListener('load', () => {
    //   // const preloader = document.getElementById('preloader');
    //   setPreeLoader(false)
    //   // preloader.style.display = 'none';
    // });
  }, [])

  useEffect(() => {

    const loaderTime = setTimeout(() => {
      document.querySelector('#loader').style.display = "none"
    }, 25000);


    return () => clearTimeout(loaderTime)
  }, [])

  window.addEventListener("scroll", onScrollWindow);
  useEffect(() => {
    AOS.init({
      offset: 100,
      delay: 100,
      duration: 1500,
      once: true

    });
  }, [])
  const ref = useRef()
  const onScroll = (event) => {
    const Scrolled = event.target.scrollTop;
    const MaxHeight = event.target.scrollHeight - event.target.clientHeight;
    ref.current = (Scrolled / MaxHeight) * 100;
    setScroll(ref.current);

  };

  const location = useLocation()

  return (
    <div style={{ maxHeight: `${preeLoader ? "100vh" : ""}`, scrollbarColor: `${preeLoader ? "none" : ""}` }}>
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition={Slide}
      />
      <div id='loader' className={`${preeLoader ? "showloader" : "hideLoader"} pageLoader`}>
        <AnimatedHero />
      </div>
      <div className={`${preeLoader ? "hideMain" : 'showMain'} App`} onClick={() => setShowNav('sideNav')}>

        <Navbar showNav={showNav} setShowNav={setShowNav} scrol={ref.current} />
        <AnimatePresence mode="wait" >
          <Routes key={location.pathname} location={location}>
            <Route path='/' element={<Home onScroll={onScroll} />} />
            <Route path='/why-us' element={<WhyUs />} />
            <Route path='/approaches' element={<Approach />} />
            <Route path='/service-work' element={<ServiceAndWork />} />
            <Route path='/about' element={<About />} />
            <Route path='/portfolio' element={<Portfolio />} />
            <Route path='/contact' element={<Contact />} />
          </Routes>
        </AnimatePresence>
        <Footer scrol={scrol} />
      </div>
    </div>
  );
}

export default App;
